import '@/src/api/client';
import {
  browserVoiceSignalingControllerGetConfig,
  browserVoiceSignalingControllerIngest,
} from '@/src/api/generated/sdk.gen';
import type {
  BrowserVoiceObservabilityConfigDto,
  BrowserVoiceSignalingEventV1Dto,
} from '@/src/api/generated/types.gen';

export type BrowserVoiceObservabilityMode = BrowserVoiceObservabilityConfigDto['mode'];
export type BrowserVoiceObservabilityConfig = BrowserVoiceObservabilityConfigDto;
export type BrowserVoiceSignalingEvent = BrowserVoiceSignalingEventV1Dto;

export async function getBrowserVoiceObservabilityConfig(): Promise<BrowserVoiceObservabilityConfig> {
  const response = await browserVoiceSignalingControllerGetConfig();
  if (response.error || !response.data) {
    throw new Error('Voice observability config request failed.');
  }
  return response.data;
}

export async function postBrowserVoiceSignalingEvents(
  events: readonly BrowserVoiceSignalingEvent[],
  keepalive: boolean,
): Promise<void> {
  const response = await browserVoiceSignalingControllerIngest({
    body: { events: [...events] },
    // The generated Fetch client options extend RequestInit, so terminal
    // delivery can retain the browser's keepalive semantics without bypassing
    // the generated endpoint, types, configured client, or auth handling.
    keepalive,
  });
  if (response.error || !response.data) {
    throw new Error('Voice observability event request failed.');
  }
}
